import { VERTICAL_EMBED_TYPE } from 'wix-rich-content-common';
import { hasPlugin as hasPluginInPlugins } from '@wix/ricos-common';
import { verticalEmbedViewerStrategy } from './verticalEmbedViewerStrategy/verticalEmbedViewerStrategy';
export var runViewerStrategies = function (plugins, baseUrl, previewMode) {
    var hasPlugin = function (pluginType) { return hasPluginInPlugins(pluginType, plugins); };
    return baseUrl && hasPlugin(VERTICAL_EMBED_TYPE)
        ? verticalEmbedViewerStrategy(baseUrl, previewMode)
        : {};
};
//# sourceMappingURL=runViewerStrategies.js.map